import { type FC, type RefObject, useMemo } from 'react';

import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type { SpreadsheetSettings } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import { DateTimeEditor } from '@/components/UI/SpreadSheet/editors/DateTimeEditor';
import Handsontable from 'handsontable';
import type { CellChange } from '@/support/hot.types';

import { formatNumber } from '@/helpers.tsx';

import { createSummaryDisplayValueRenderer, createSummarySpreadsheetSettings } from './Summary.utils';
import type { SummaryTableProps } from './Summary.models';

const displayValueRenderer = createSummaryDisplayValueRenderer<Handsontable.Core, Handsontable.CellProperties>({
  callTextRenderer: (thisArg, instance, td, row, col, prop, value, cellProperties) => {
    Handsontable.renderers.TextRenderer.call(thisArg, instance, td, row, col, prop, value, cellProperties);
  },
  formatNumber,
});

const SpreadSheet: FC<SummaryTableProps> = ({ dosages, metadata, innerRef, onAfterChange }) => {
  const settings = useMemo<SpreadsheetSettings>(
    () =>
      createSummarySpreadsheetSettings({
        displayValueRenderer: displayValueRenderer,
        dateTimeColumnType: DateTimeEditor.type,
      }) as SpreadsheetSettings,
    []
  );

  return (
    <Spreadsheet
      className={'mt3'}
      data={dosages as unknown as Array<Record<string, unknown>>}
      settings={settings}
      metadata={metadata}
      addCol={false}
      innerRef={innerRef as RefObject<HotTableRef>}
      maxRows={dosages.length}
      afterChange={(changes: CellChange[] | null) => onAfterChange(changes)}
    />
  );
};

export default SpreadSheet;
